import React from 'react'
import { Stack, Textarea } from '@mantine/core'

interface LocationDescriptionStepProps {
  locationDescription: string | null | undefined
  updateLocationDescription: (description: string) => void
}

const LocationDescriptionStep = ({
  locationDescription,
  updateLocationDescription,
}: LocationDescriptionStepProps) => {
  return (
    <Stack align='center' pb='lg' ml='sm' mr='sm' w='100%'>
      <Textarea
        w='100%'
        maw={600}
        placeholder='This is your time to shine! Let future advertisers know a little bit about your business and why they would want to advertise at your location.'
        rows={6}
        resize='vertical'
        maxLength={500}
        value={locationDescription ?? ''}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
          updateLocationDescription(e.target.value)
        }
      />
    </Stack>
  )
}

export default LocationDescriptionStep
